jQuery(function () {
 jQuery("#append-post").on("click", function () {
  var button = jQuery(this),
   post_type = button.data("pt"),
   data = {
    action: "loadmore",
    query: append_post_params.posts,
    page: append_post_params.current_page,
    post_type: post_type ? post_type : "post", //ボタンのdata-pt属性の指定が無ければpostを指定する
   };

  jQuery
   .ajax({
    url: append_post_params.ajaxurl,
    data: data,
    type: "POST",
    beforeSend: function (xhr) {
     button.addClass("news-loading").text("読み込み中").wrapInner('<span class="n-loading" />');
    },
   })
   .then(
    //通信成功時
    function (data) {
     button.removeClass("news-loading").text("もっと見る").wrapInner('<span class="n-btn" />').prev().append(data);
     append_post_params.current_page++;
     //これ以上読み込む記事が無ければ読み込みボタン削除
     if (append_post_params.current_page == append_post_params.max_page) {
      button.remove();
     }
    },
    //通信エラー時
    function () {
     button.remove();
    }
   );
 });
});
